export const GLOBAL_CONFIG_KEY = '_fwGlobalConfig'
export const PARAM_PREFIX = 'fwparam_'
